import icon from '@plone/volto/icons/list-bullet.svg';

import CustomEdit from './components/Custom/CustomEdit';
import CustomView from './components/Custom/CustomView';
import CustomBlockSchema from './components/Custom/schema';

import HeadlineWithBubblesEdit from './components/HeadlineWithBubbles/HeadlineWithBubblesEdit';
import HeadlineWithBubblesView from './components/HeadlineWithBubbles/HeadlineWithBubblesView';
import HeadlineWithBubblesSchema from './components/HeadlineWithBubbles/schema';

import ReferenceFilterEdit from './components/ReferenceFilter/ReferenceFilterEdit';
import ReferenceFilterView from './components/ReferenceFilter/ReferenceFilterView';
import ReferenceFilterSchema from './components/ReferenceFilter/schema';

import HtmlContentEdit from './components/HtmlContent/HtmlContentEdit';
import HtmlContentView from './components/HtmlContent/HtmlContentView';
import HtmlContentSchema from './components/HtmlContent/schema';
import Matomo from './components/Matomo';

const applyConfig = (config) => {
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['de', 'en'];
  config.settings.defaultLanguage = 'de';

  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '', // Matches all routes/pages
      component: Matomo,
    },
  ];

  config.blocks.blocksConfig.customBlock = {
    id: 'customBlock',
    title: 'CUSTOM',
    edit: CustomEdit,
    view: CustomView,
    schema: CustomBlockSchema,
    icon: icon,
    group: 'text',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.referenceFilter = {
    id: 'referenceFilter',
    title: 'ReferenceFilter',
    edit: ReferenceFilterEdit,
    view: ReferenceFilterView,
    schema: ReferenceFilterSchema,
    icon: icon,
    group: 'text',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.headlineWithBubbles = {
    id: 'headlineWithBubbles',
    title: 'Headline With Bubbles',
    edit: HeadlineWithBubblesEdit,
    view: HeadlineWithBubblesView,
    schema: HeadlineWithBubblesSchema,
    icon: icon,
    group: 'text',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.htmlContent = {
    id: 'htmlContent',
    title: 'X-HTML Content',
    edit: HtmlContentEdit,
    view: HtmlContentView,
    schema: HtmlContentSchema,
    icon: icon,
    group: 'text',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  return config;
};

export default applyConfig;
